import { useMutation } from "react-query";
import { axiosInstance } from "../../../../utils/axiosInstance";
import { message } from "antd";
import { queryClient } from "../../../../services/queryClient";

export const useUpdateStudentProfileMutation = ({
  timezone,
}: {
  timezone: string;
}) => {
  const token = localStorage.getItem("W2ST_STUDENT_TOKEN");

  return useMutation(
    () =>
      axiosInstance
        .put(
          "auth/update-profile",
          { timezone: timezone },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res: any) => res.data),
    {
      onSuccess: async () => {
        message.success("Timezone updated successfully.");
        queryClient.invalidateQueries("getuser");
      },
      onError: (error: any) => {
        message.error(
          error?.response?.data?.message ||
            "Failed to update timezone. Please try again."
        );
      },
    }
  );
};
